import Btn from '../Btn/index'
import TransactionsDetailedHeader from '../TransactionsDetailedHeader/index'
import { mapGetters } from 'vuex'
export default {
  name: 'ProfileContent',
  components: { Btn, TransactionsDetailedHeader },
  props: ["nav", "device",],
  data () {
    return {
      //enableInvite: 1
    }
  },
  computed: {
    ...mapGetters([
      "user"
    ])
  },
  mounted () {
  },
  methods: {
    activeClass (link, name) {
      if (this.device == 'mobile') return;
      if (name == link) return 'active'
    },
    logout () {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "SCREEN",
        propertyName: "SCREEN_NAME",
        propertyValue: "LOGOUT"
      });
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "Login" })
      }).catch(() => {
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ProfileContent/component.js